import styled, { css } from 'styled-components';

import Container from 'ggApp/shared/common/Container';
import { transition } from 'ggApp/utils/mixins/transition';

import PageLink from './PageLink';

const ItemStyles = css`
    color: ${({ theme }) => theme.colors.Foreground};
    &:not(:last-child) {
        margin-right: ${({ theme }) => theme.spacers.XL};
    }
    &:hover,
    &:active,
    &:focus {
        color: ${({ theme }) => theme.colors.Foreground};
        opacity: 0.5;
    }
    > * {
        cursor: pointer;
    }
    ${({ theme }) => theme.superQuery.all.and.maxWidth.mobileMax.css`
        margin: 0 0 0 auto;
    `};
    ${transition('color', 'medium-desktop', 'standard')};
`;

const Button = styled('button')`
    ${({theme}) => css(theme.typography.SmallCapsHeadline)};
    ${ItemStyles};
    cursor: pointer;
    background: none;
    border: none;
    text-align: left;

    &:active {
        color: ${({ theme }) => theme.colors.Foreground};
        opacity: 1;
    }
`

const Link = styled(PageLink)`
    ${ItemStyles}
`;

const IntercomTrigger = styled.p`
    ${ItemStyles}
    ${({theme}) => css(theme.typography.SmallCapsHeadline)};
    &:not(:last-child) {
        margin-right: 24px;
    }
    ${({ theme }) => theme.superQuery.all.and.maxWidth.mobileMax.css`
        margin: 0 0 0 auto;
    `};
`

const Wrap = styled(Container)`
    ${Link} {
        ${({ theme, isTransparent }) => isTransparent && `
            color: ${theme.colors.Background};
        `};
    }
`;

export {
    Wrap,
    Link,
    Button,
    IntercomTrigger
};
